import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/bold-text.svg";
var BoldTextSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  BoldTextSolid_default as default
};
